import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Modal,
  Button,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@emotion/react";
import estadoDespacho from "../../../api/estadoDespacho";
import MenuSection from "../../MenuSection";
import qrImage from "../../../images/qrImage.png";
import QRTEST from "../../../images/QRs/QR-TEST.png";

export const PagoKioskPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const esYPF = localStorage.getItem("bandera") === "ypf";
  const esKiosk = JSON.parse(localStorage.getItem("esKiosk")) || false;

  // Estados para el procesamiento de pagos
  const [isLoading, setIsLoading] = useState(false);
  const [mensajeDeEspera, setMensajeDeEspera] = useState("");
  const [showQRModal, setShowQRModal] = useState(false);
  const [qrType, setQRType] = useState("");
  const [total, setTotal] = useState("0.00");

  // Duraciones como en FormasDePagoPage
  const DURACION_ESPERA_PAGO = 3000; // 3 segundos
  const DURACION_PROCESAMIENTO_PAGO = 1500; // 1.5 segundos

  // Obtener parámetros de la URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const metodoPago = searchParams.get("metodoPago");
    const totalPago = searchParams.get("total");

    if (totalPago) {
      setTotal(totalPago);
    }

    if (metodoPago) {
      ejecutarMetodoPago(metodoPago);
    }
  }, [location]);

  // Funciones de pago (basadas en FormasDePagoPage)
  const handleDebito = async () => {
    setMensajeDeEspera("ESPERANDO TARJETA...");

    setTimeout(() => {
      setMensajeDeEspera("");
      setIsLoading(true);

      setTimeout(async () => {
        await procesarPago();
      }, DURACION_PROCESAMIENTO_PAGO);
    }, DURACION_ESPERA_PAGO);
  };

  const handleCredito = () => {
    navigate("/cuotaspage");
  };

  const mandarAImprimir = () => {
    const facturaInfoString = localStorage.getItem("facturaInfo");
    const facturaInfo = JSON.parse(facturaInfoString);
    const imprimir = true;
    localStorage.setItem("limpiarArticulos", false);
    navigate("/ticket/", { state: { facturaInfo, imprimir } });
  };

  const handleEfectivo = async () => {
    setMensajeDeEspera("ESPERANDO PAGO EN EFECTIVO...");

    setTimeout(() => {
      setMensajeDeEspera("");
      setIsLoading(true);

      setTimeout(async () => {
        await procesarPago();
      }, DURACION_PROCESAMIENTO_PAGO);
    }, DURACION_ESPERA_PAGO);
  };

  const handleQRYPF = () => {
    setQRType("YPF");
    setShowQRModal(true);

    setTimeout(() => {
      setShowQRModal(false);
      setIsLoading(true);

      setTimeout(async () => {
        await procesarPago();
      }, 3000);
    }, 5000);
  };

  const handleMercadoPago = () => {
    setQRType("MERCADOPAGO");
    setShowQRModal(true);

    setTimeout(() => {
      setShowQRModal(false);
      setIsLoading(true);

      setTimeout(async () => {
        await procesarPago();
      }, 3000);
    }, 5000);
  };

  const handleModo = () => {
    setQRType("MODO");
    setShowQRModal(true);

    setTimeout(() => {
      setShowQRModal(false);
      setIsLoading(true);

      setTimeout(async () => {
        await procesarPago();
      }, 3000);
    }, 5000);
  };

  // Función común para procesar el pago
  const procesarPago = async () => {
    try {
      const despachosSeleccionados = localStorage.getItem(
        "despachosSeleccionados",
      );

      if (despachosSeleccionados) {
        const despachosArray = JSON.parse(despachosSeleccionados);
        for (const despachoId of despachosArray) {
          await estadoDespacho.actualizarDespacho(despachoId, 1, 1);
        }
      }
      if (esYPF && esKiosk) {
        mandarAImprimir();
        return;
      }
      navigate("/dialogoimprimirfacturapage");
    } catch (error) {
      console.error("Error al procesar pago:", error);
      setIsLoading(false);
      setMensajeDeEspera("Error en el procesamiento. Intente nuevamente.");
    }
  };

  // Ejecutar el método de pago correspondiente
  const ejecutarMetodoPago = metodoPago => {
    switch (metodoPago) {
      case "ypf":
        handleQRYPF();
        break;
      case "mercadopago":
        handleMercadoPago();
        break;
      case "modo":
        handleModo();
        break;
      case "credito":
        handleCredito();
        break;
      case "debito":
        handleDebito();
        break;
      case "efectivo":
        handleEfectivo();
        break;
      default:
        console.log("Método de pago no reconocido");
        navigate(-1); // Volver atrás si no se reconoce el método
    }
  };

  return (
    <>
      <MenuSection />

      {/* SPINNER DE CARGA Y MENSAJE DE ESPERA */}
      {(isLoading || mensajeDeEspera) && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            bgcolor: "rgba(255, 255, 255, 0.98)",
            zIndex: 9999,
          }}
        >
          <CircularProgress
            size={150}
            sx={{ color: theme.bandera.colorSecundario }}
          />
          <Typography
            variant="h3"
            sx={{
              mt: 10,
              fontWeight: "bold",
              color: "#333",
              textAlign: "center",
            }}
          >
            {mensajeDeEspera || "PROCESANDO PAGO..."}
          </Typography>

          {/* Mostrar el total durante el procesamiento */}
          {!mensajeDeEspera && (
            <Typography
              variant="h5"
              sx={{
                mt: 2,
                fontWeight: "bold",
                color: theme.bandera.colorSecundario,
                fontSize: "1.8rem",
              }}
            >
              Total: ${total}
            </Typography>
          )}
        </Box>
      )}

      {/* MODAL QR (YPF/MERCADOPAGO/MODO) */}
      {showQRModal && (
        <Modal
          open={showQRModal}
          onClose={() => {}} // No permitir cerrar el modal
          aria-labelledby="qr-modal-title"
          aria-describedby="qr-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "400px",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 4,
              textAlign: "center",
              outline: "none",
            }}
          >
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{
                color: "#333",
                marginBottom: 2,
                fontSize: "1.3rem",
              }}
            >
              Escanea el QR para confirmar el pago
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#666",
                marginBottom: 3,
              }}
            >
              {qrType === "YPF" &&
                `Usa la App ${esYPF ? "YPF " : ""}para completar tu pago`}
              {qrType === "MERCADOPAGO" &&
                "Usa Mercado Pago para completar tu pago"}
              {qrType === "MODO" && "Usa Modo para completar tu pago"}
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 2,
              }}
            >
              <CircularProgress
                size={30}
                sx={{ color: theme.bandera.colorSecundario }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 2,
              }}
            >
              <img
                src={qrImage}
                alt="QR Code"
                style={{
                  width: "200px",
                  height: "200px",
                  border: "2px solid #ddd",
                  borderRadius: "8px",
                }}
              />
            </Box>

            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{
                color: theme.bandera.colorSecundario,
                marginBottom: 3,
                fontSize: "1.5rem",
              }}
            >
              Monto: ${total}
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#d32f2f",
                color: "white",
                fontWeight: "bold",
                padding: "12px 24px",
                fontSize: "1rem",
                "&:hover": {
                  backgroundColor: "#b71c1c",
                },
              }}
              onClick={() => {
                setShowQRModal(false);
                setQRType("");
                navigate(-1); // Volver a la pantalla anterior
              }}
            >
              CANCELAR
            </Button>
          </Box>
        </Modal>
      )}

      {/* Pantalla de fondo cuando no hay procesamiento activo */}
      {!isLoading && !mensajeDeEspera && !showQRModal && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "calc(100vh - 100px)",
            flexDirection: "column",
          }}
        >
          <Typography variant="h3" sx={{ color: "#666", mb: 2, mt: 10 }}>
            Procesando solicitud...
          </Typography>
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
            sx={{ mt: 2 }}
          >
            Volver
          </Button>
        </Box>
      )}
    </>
  );
};
